import { EmissionRow } from './types'
import { interpolateRgb } from 'd3-interpolate'
import { orderBy, maxBy, groupBy, capitalize, partition } from 'lodash-es'
import { YEARS_COLORS_GRADIENT, LULUCF } from '../../lib/constants'
import datasetYears from '../../datasets/global-CIRCLES-emission-sector-year.csv'
import datasetFill from '../../datasets/global-CIRCLES-2020-emission-percentage-sector.csv'

/*
$$\     $$\ $$$$$$$$\  $$$$$$\  $$$$$$$\   $$$$$$\
\$$\   $$  |$$  _____|$$  __$$\ $$  __$$\ $$  __$$\
 \$$\ $$  / $$ |      $$ /  $$ |$$ |  $$ |$$ /  \__|
  \$$$$  /  $$$$$\    $$$$$$$$ |$$$$$$$  |\$$$$$$\
   \$$  /   $$  __|   $$  __$$ |$$  __$$<  \____$$\
    $$ |    $$ |      $$ |  $$ |$$ |  $$ |$$\   $$ |
    $$ |    $$$$$$$$\ $$ |  $$ |$$ |  $$ |\$$$$$$  |
    \__|    \________|\__|  \__|\__|  \__| \______/



*/
export const MAX_RADIUS_YEARS = 155

export const emissionsYears = orderBy(datasetYears as EmissionRow[], 'years', 'desc')
export const emissionsYearsByChallenge = groupBy(emissionsYears, 'sector')

const maxYearsPercentage = (challenge: string) =>
  maxBy(emissionsYearsByChallenge[challenge], (d) => d.emission_mmt_co2)

export const circlesYears = (challenge: string, dimensions: { w: number; h: number }) => {
  const emissions = emissionsYearsByChallenge[challenge]

  const maxEmission = maxYearsPercentage(challenge)

  return emissions.map((d: EmissionRow, i: number) => {
    const radius = MAX_RADIUS_YEARS * Math.sqrt(d.emission_mmt_co2 / maxEmission.emission_mmt_co2)
    const x = dimensions.w / 2
    const y = dimensions.h / 2 + MAX_RADIUS_YEARS - radius + 30
    const label = d.sector.toLowerCase()
    const color = interpolateYearColor(label)(i / emissions.length)
    const percentage = d.emission_percentage
    const opacity = 0
    const year = d.year
    const co2_mmt = d.emission_mmt_co2

    return { x, y, color, label, opacity, percentage, radius, year, co2_mmt }
  })
}

/*
 $$$$$$\   $$$$$$\  $$\      $$\ $$\      $$\  $$$$$$\  $$\   $$\
$$  __$$\ $$  __$$\ $$$\    $$$ |$$$\    $$$ |$$  __$$\ $$$\  $$ |
$$ /  \__|$$ /  $$ |$$$$\  $$$$ |$$$$\  $$$$ |$$ /  $$ |$$$$\ $$ |
$$ |      $$ |  $$ |$$\$$\$$ $$ |$$\$$\$$ $$ |$$ |  $$ |$$ $$\$$ |
$$ |      $$ |  $$ |$$ \$$$  $$ |$$ \$$$  $$ |$$ |  $$ |$$ \$$$$ |
$$ |  $$\ $$ |  $$ |$$ |\$  /$$ |$$ |\$  /$$ |$$ |  $$ |$$ |\$$$ |
\$$$$$$  | $$$$$$  |$$ | \_/ $$ |$$ | \_/ $$ | $$$$$$  |$$ | \$$ |
 \______/  \______/ \__|     \__|\__|     \__| \______/ \__|  \__|



*/

function interpolateYearColor(label: string) {
  const [past, present] = YEARS_COLORS_GRADIENT[label]

  return interpolateRgb(past, present)
}

const datasetWithSeparatedLulucf = partition(
  orderBy(datasetFill as any, 'emission_percentage'),
  (d) => d.sector !== LULUCF
)

export const datasetSortedByEmPerc = datasetWithSeparatedLulucf[0] as EmissionRow[]
export const lulucfEmPerc = datasetWithSeparatedLulucf[1][0]
